export const useGA4 = () => {
  const { acceptedAnalytics } = useConsent()

  const {
    public: { ga4Id },
  } = useRuntimeConfig()

  return useScriptGoogleAnalytics({
    id: ga4Id,
    scriptOptions: {
      trigger: acceptedAnalytics,
    },
    onBeforeGtagStart: (gtag) => {
      gtag('consent', 'default', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
      })
    },
  })
}
